import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  text: {
    color: "#4F4F4F",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
}));

export default function MenuButton({ title, onClick, icon, redirect }) {
  const classes = useStyles();

  return (
    <Button
      /* variant="outlined" */
      color="gray"
      /* endIcon={<ArrowForwardIosIcon color="secondary" />} */
      onClick={onClick}
      startIcon={icon}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50px",
       
      }}
      fullWidth
    >
      <Link
        style={{
          textDecoration: "none",
          color: "#4F4F4F",
          fontSize: "0.975rem",
          fontWeight: 500,
          
        }}
        to={redirect}
      >
        <p>{title}</p>
      </Link>
    </Button>
  );
}

MenuButton.defaultProps = {};

MenuButton.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
};
